module.exports = __webpack_public_path__ + "static/media/icon-phone.9393a7fd.svg";